import React, { useState, useRef } from 'react'
import { Icon } from '..'
import cn from 'classnames'

interface CheckboxProps extends React.ComponentProps<'input'> {
  label?: string | JSX.Element
  containerClass?: string
}

const Checkbox: React.FC<CheckboxProps> = ({ label, containerClass, ...props }) => {
  const checkboxRef: React.RefObject<any> = useRef()
  const [checked, setChecked] = useState(props.checked ?? false)

  return (
    <div
      className={cn('checkbox-container', containerClass, {
        'checkbox-container--checked': checked
      })}
    >
      <label className='mb-0 d-flex justify-content-center align-items-center'>
        <div className='checkbox'>
          <input
            onChange={e => setChecked(e.target.checked)}
            checked={checked}
            ref={checkboxRef}
            type='checkbox'
            {...props}
          />
          <Icon containerClass={cn('checkbox__icon completeCenter h-100 w-100')} type='check' />
        </div>
        {label && (
          <h6
            className={cn('checkboxAndRadioFont checkbox__label', {
              'checkbox__label--checked': checked
            })}
          >
            {label}
          </h6>
        )}
      </label>
    </div>
  )
}

export default Checkbox
